module.exports = __webpack_public_path__ + "static/media/pro.ddde26bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pro.png
// module id = 134
// module chunks = 1